import { Fab, FabProps } from '@mui/material';

import fabTheme from './Fab';

export { fabTheme };
export default Fab;
export type { FabProps };
